export enum categoriesOwnerHomeType {
  THISYEAR = "thisyear",
  THISMONTH = "thismonth",
  THISWEEK = "thisweek",
  THISDAY = "thisday",
  CUSTOM = "custom",
}
